import { useNavigate } from 'react-router-dom';

export const useTagNavigation = () => {
  const navigate = useNavigate();

  const navigateToWorkWithTag = (tag) => {
    navigate(`/work?tag=${encodeURIComponent(tag)}`);
  };

  return { navigateToWorkWithTag };
};

// For components that don't have access to useNavigate hook
export const createTagNavigationHandler = (navigate) => {
  return (tag) => {
    navigate(`/work?tag=${encodeURIComponent(tag)}`);
  };
};
